import React from 'react';
import Icon from '../../../components/AppIcon';

const RecentActivityItem = ({ activity }) => {
  const getActivityIcon = (type) => {
    const icons = {
      'project-created': 'Plus',
      'project-updated': 'Edit',
      'stage-completed': 'CheckCircle',
      'subscription-upgraded': 'TrendingUp',
      'book-published': 'Send'
    };
    return icons?.[type] || 'Activity';
  };

  const getActivityColor = (type) => {
    const colors = {
      'project-created': 'text-success',
      'project-updated': 'text-primary',
      'stage-completed': 'text-accent',
      'subscription-upgraded': 'text-secondary',
      'book-published': 'text-success'
    };
    return colors?.[type] || 'text-muted-foreground';
  };

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffInHours = Math.floor((now - date) / (1000 * 60 * 60));

    if (diffInHours < 1) return 'Just now';
    if (diffInHours < 24) return `${diffInHours}h ago`;
    if (diffInHours < 48) return 'Yesterday';
    return date?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  return (
    <div className="flex items-start space-x-3 py-3 border-b border-border last:border-0">
      <div className={`flex-shrink-0 w-8 h-8 rounded-full bg-muted flex items-center justify-center ${getActivityColor(activity?.type)}`}>
        <Icon name={getActivityIcon(activity?.type)} size={16} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm text-foreground mb-1">
          {activity?.description}
        </p>
        <span className="text-xs text-muted-foreground">
          {formatTimestamp(activity?.timestamp)}
        </span>
      </div>
    </div>
  );
};

export default RecentActivityItem;